import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-end" };
const _hoisted_2 = ["onUpdate:modelValue"];
const _hoisted_3 = ["onUpdate:modelValue"];
const _hoisted_4 = ["onUpdate:modelValue"];
const _hoisted_5 = ["onUpdate:modelValue"];
const _hoisted_6 = { class: "d-flex flex-wrap" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-auto" };
const _hoisted_10 = { class: "form-floating" };
const _hoisted_11 = ["id"];
const _hoisted_12 = ["for"];
const _hoisted_13 = { class: "col-auto" };
const _hoisted_14 = { class: "form-floating" };
const _hoisted_15 = ["id"];
const _hoisted_16 = ["for"];
const _hoisted_17 = { class: "col-auto" };
const _hoisted_18 = { class: "form-check" };
const _hoisted_19 = ["id"];
const _hoisted_20 = ["for"];
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { router, useForm } from '@inertiajs/vue3';
import { ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import axios from 'axios';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VariantComponentColors',
    props: {
        lidVariantComponent: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage, showSuccessMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const componentKey = ref(Math.random().toString(36).substring(2, 15));
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const createColorForm = useForm({
            name: null,
            hex: null,
            rgb: null,
            isDefault: false
        });
        const componentColors = ref(props.lidVariantComponent?.colors ?? []);
        function loadComponentColors() {
            if (props.lidVariantComponent == null) {
                return;
            }
            axios.post(route('admin.lids.variants.components.colors.load', props.lidVariantComponent.uuid)).then((response) => {
                componentColors.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function create() {
            if (props.lidVariantComponent == null) {
                return;
            }
            createColorForm.transform((data) => ({
                name: data.name,
                hex: data.hex,
                rgb: data.rgb,
                is_default: data.isDefault
            }))
                .submit('post', route('admin.lids.variants.components.colors.store', props.lidVariantComponent.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    loadComponentColors();
                    createColorForm.reset();
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        const onCellEditComplete = (event) => {
            let { newData } = event;
            axios.post(route('admin.lids.variants.components.colors.update', newData.uuid), {
                name: newData.name,
                name_en: newData.nameEn,
                hex: newData.hex,
                rgb: newData.rgb,
                is_default: newData.isDefault
            }).then((response) => {
                componentColors.value = componentColors.value.map((color) => {
                    if (color.uuid === newData.uuid) {
                        color.name = newData.name;
                        color.nameEn = newData.nameEn;
                        color.hex = newData.hex;
                        color.rgb = newData.rgb;
                        color.isDefault = newData.isDefault;
                        if (newData.isDefault) {
                            componentColors.value.forEach((c) => {
                                if (c.uuid !== newData.uuid) {
                                    c.isDefault = false;
                                }
                            });
                        }
                    }
                    return color;
                });
                showSuccessMessage('Änderungen gespeichert');
            }).catch((error) => {
                showErrorMessage(error);
            });
        };
        function remove(componentColor) {
            confirm.require({
                message: 'Soll die Einfärbung wirklich gelöscht werden?',
                header: 'Einfärbung löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.lids.variants.components.colors.destroy', componentColor.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            loadComponentColors();
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(DataTable), {
                    class: "mb-4",
                    dataKey: "id",
                    value: componentColors.value,
                    stripedRows: "",
                    responsiveLayout: "scroll",
                    globalFilterFields: ['name', 'name_en', 'hex', 'default'],
                    filters: tableFilter.value,
                    "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                    paginator: true,
                    rows: 10,
                    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                    rowsPerPageOptions: [10, 25, 50, 150],
                    currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}",
                    editMode: "cell",
                    onCellEditComplete: onCellEditComplete
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                placeholder: "Suche",
                                style: { "width": "250px" }
                            }, null, 512), [
                                [_vModelText, tableFilter.value['global'].value]
                            ])
                        ])
                    ]),
                    empty: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                        ]))]),
                    loading: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Einträge werden geladen ... ", -1)
                        ]))]),
                    default: _withCtx(() => [
                        _createVNode(_unref(Column), {
                            header: "#",
                            sortable: true
                        }, {
                            body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Name",
                            sortable: true,
                            sortField: "name"
                        }, {
                            body: _withCtx(({ data }) => [
                                _createTextVNode(_toDisplayString(data.name), 1)
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event) => ((data.name) = $event),
                                    style: { "width": "100px" },
                                    required: ""
                                }, null, 8, _hoisted_2), [
                                    [_vModelText, data.name]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Name (en)",
                            sortable: true,
                            sortField: "nameEn"
                        }, {
                            body: _withCtx(({ data }) => [
                                _createTextVNode(_toDisplayString(data.nameEn), 1)
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event) => ((data.nameEn) = $event),
                                    style: { "width": "100px" },
                                    required: ""
                                }, null, 8, _hoisted_3), [
                                    [_vModelText, data.nameEn]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Hex",
                            sortable: true,
                            sortField: "hex"
                        }, {
                            body: _withCtx(({ data }) => [
                                _createTextVNode(_toDisplayString(data.hex), 1)
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event) => ((data.hex) = $event),
                                    style: { "width": "100px" },
                                    required: ""
                                }, null, 8, _hoisted_4), [
                                    [_vModelText, data.hex]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), {
                            header: "Default",
                            sortable: true,
                            sortField: "isDefault"
                        }, {
                            body: _withCtx((slotProps) => [
                                _createVNode(YesNoIcon, {
                                    answer: slotProps.data.isDefault
                                }, null, 8, ["answer"])
                            ]),
                            editor: _withCtx(({ data }) => [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    "onUpdate:modelValue": ($event) => ((data.isDefault) = $event)
                                }, null, 8, _hoisted_5), [
                                    [_vModelCheckbox, data.isDefault]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(Column), { header: "" }, {
                            body: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        class: "btn",
                                        onClick: ($event) => (remove(slotProps.data))
                                    }, [...(_cache[7] || (_cache[7] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle text-danger",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1)
                                        ]))], 8, _hoisted_7)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["value", "filters"]),
                _createElementVNode("form", {
                    onSubmit: _withModifiers(create, ["prevent"])
                }, [
                    _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "fw-bold mb-3" }, "Neue Einfärbung", -1)),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("input", {
                                    id: 'componentColorName' + componentKey.value,
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createColorForm).name) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_11), [
                                    [_vModelText, _unref(createColorForm).name]
                                ]),
                                _createElementVNode("label", {
                                    for: 'componentColorName' + componentKey.value
                                }, "Name", 8, _hoisted_12)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _withDirectives(_createElementVNode("input", {
                                    id: 'componentColorHex' + componentKey.value,
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createColorForm).hex) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_15), [
                                    [_vModelText, _unref(createColorForm).hex]
                                ]),
                                _createElementVNode("label", {
                                    for: 'componentColorHex' + componentKey.value
                                }, "Hex", 8, _hoisted_16)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    id: 'componentColorDefault' + componentKey.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createColorForm).isDefault) = $event))
                                }, null, 8, _hoisted_19), [
                                    [_vModelCheckbox, _unref(createColorForm).isDefault]
                                ]),
                                _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: 'componentColorDefault' + componentKey.value
                                }, "Default?", 8, _hoisted_20)
                            ])
                        ]),
                        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"col-auto d-flex align-items-center\"><button type=\"submit\" class=\"btn btn-success d-inline-flex align-items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-check2\" viewBox=\"0 0 16 16\"><path d=\"M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0\"></path></svg><span class=\"ms-2\">Speichern</span></button></div>", 1))
                    ])
                ], 32)
            ], 64));
        };
    }
});
